export const TAG = 'Tag';
export const TAG_LINK = 'TagLink';
//# sourceMappingURL=tag.js.map